/*
 * Created Date: 29-01-2024, 1:25:16 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Thu Mar 21 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { useBreakpoints } from '@Core/hooks'
import { useLayoutContext } from '@App/Studio/Layout'
// import { CurrentWorkspace } from '@Layout/Header'
import { Box, Button, Drawer, Typography } from '@mui/material'
import React from 'react'
import { FaWindowClose } from 'react-icons/fa'
import SidebarContentV2 from './SidebarContentV2'
// import PropTypes from 'prop-types'

const Sidebar = props => {
	const { layoutConfig, openMobileSidebar, toggleOpenMobileSidebar } = useLayoutContext()

	const { laptop, mobile } = useBreakpoints()
	// console.log('🚀 ~ Sidebar ~ mobile:', mobile)
	return !laptop ? (
		<>
			<Drawer
				ModalProps={{
					keepMounted: true
				}}
				PaperProps={{ className: 'w-max' }}
				anchor="left"
				open={openMobileSidebar}
				onClose={toggleOpenMobileSidebar}
			>
				<SidebarContentV2 />
			</Drawer>
		</>
	) : (
		<SidebarContentV2 />
	)
}

// Sidebar.defaultProps = {}

// Sidebar.propTypes = {}

export default React.memo(Sidebar)
